import React from 'react'
import RealProjectOrder from '../_modals/RealProjectOrder'

export const modals: {
  [key: string]: React.SFC
} = {
  order: RealProjectOrder,
}
